import { gql } from "apollo-boost"

export const getProjectsDashboardsTotals = gql`
query ProjectsTotalsDashboards($where: DashboardProjectsWhere) {
  ApprovedByRegion(where: $where) {
    region
    totalAmount
  }
  ApprovedByStrategicAxis(where: $where) {
    regions
    totalAmount
    strategicAxis
  }
}
`